import { RootState } from "redux/store";
import { Modal } from "react-bootstrap";
import { useEffect, useState } from "react";
import { PopupTopBar, ProTable } from "components";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { cleanPbsManufacturersDetails, updateManufacturersField, addDeselectedRows, addSelectedRows, getPbsManufacturers } from "redux/slices/PbsManufacturers";
import { getManufacturers } from "redux/slices/ManagedManufacturers";

type ManufacturersProps = {
	show: boolean;
	onClose: () => void;
	onSave: () => void;
}

export function Manufacturers(props: ManufacturersProps) {
	const dispatch = useAppDispatch();
	const [saving, setSaving] = useState(false);
	const manufacturers = useAppSelector((state: RootState) => state.pbsManufacturers);
	const catalogue = useAppSelector((state: RootState) => state.catalogues);
	const [counterSelectedRows, setCounterSelectedRows] = useState<number>(0);
	const columnsb = [
		{
			Header: "Name",
			accessor: "name",
			width: 400,
		},
		{
			Header: "Code",
			accessor: "code",
			width: 500,
		}
	];

	useEffect(() => {
		if (props.show) {
			setSaving(false);
			dispatch(cleanPbsManufacturersDetails());
			dispatch(getPbsManufacturers({ 
				offset: 0,
				limit:100,
			}));
		}
	}, [props.show]);

	useEffect(() => {
		let rows = 0;
		if (!manufacturers.selectedRows) setCounterSelectedRows(0);
		if (manufacturers.selectAllFilter) {
			let deselectedRows = 0;
			manufacturers.deselectedRows.forEach((row: any) => deselectedRows = deselectedRows + row.length);
			rows = manufacturers.totalRows - deselectedRows;
		} else {
			manufacturers.selectedRows.forEach((row: any) => rows = rows + row.length);
		}
		setCounterSelectedRows(rows);
	}, [manufacturers.selectedRows, manufacturers.deselectedRows]);

	useEffect(() => {
		columnCheckDeselectAll();
	}, [manufacturers.pageSize]);

	function onSearchClick(keyword: string) {
		handleChange("keyword", keyword);
		dispatch(updateManufacturersField({ key: "pageIndex", value: 0 }));
		columnCheckDeselectAll();
		dispatch(getPbsManufacturers({
			keyword: keyword,
			offset: 0,
			limit: manufacturers.pageSize,
		}));
	}

	function handleChange(option: any, optionValue: any) {
		dispatch(updateManufacturersField({ key: option, value: optionValue }));
	}

	function updateTableRows(dataTableState: any) {
		dispatch(updateManufacturersField({ key: "pageIndex", value: dataTableState.pageIndex }));
		dispatch(updateManufacturersField({ key: "pageSize", value: dataTableState.pageSize }));
		dispatch(getPbsManufacturers({
			keyword: catalogue.keyword,
			offset: dataTableState.pageIndex * dataTableState.pageSize,
			limit: dataTableState.pageSize,
		}));
	}

	function deselectedRowsUpdate(rows: any, index: any) {
		dispatch(addDeselectedRows({ rows: rows, index: index }));
	}

	function selectedRowsUpdate(rows: any, index: any) {
		dispatch(addSelectedRows({ rows: rows, index: index }));
	}

	function columnCheckDeselectAll() {
		handleChange("selectAllFilter", false);
		handleChange("deselectedRows", []);
		handleChange("selectedRows", []);
	}

	function columnCheckSelectAll() {
		handleChange("selectAllFilter", true);
		handleChange("deselectedRows", []);
	}

	function saveSelectedRows() {
		setSaving(true);
		props.onSave();
	}

	return (
		<Modal size="lg" centered show={props.show} onHide={props.onClose}>
			<Modal.Header closeButton>
				<Modal.Title>Manufacturers</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<ProTable
					data={manufacturers}
					pageSize={100}
					isSortable={true}
					pagination={true}
					disableExport={true}
					columns={columnsb}
					table={manufacturers.table}
					loading={manufacturers.loading}
					updateTableRows={updateTableRows}
					// Search Props
					isSearchable={true}
					onSearchClick={onSearchClick}
					// Select Props
					isSelectable={true}
					selectAllFilter={manufacturers.selectAllFilter}
					selectedRows={manufacturers.selectedRows}
					deselectedRows={manufacturers.deselectedRows}
					selectedRowsUpdate={selectedRowsUpdate}
					deselectedRowsUpdate={deselectedRowsUpdate}
					columnCheckSelectAll={columnCheckSelectAll}
					columnCheckDeselectAll={columnCheckDeselectAll}
					// Extra Components Props
					topbarChild={<PopupTopBar counter={counterSelectedRows} onSave={saveSelectedRows} saving={saving} />}
				/>
			</Modal.Body>
		</Modal>
	);
}